// src/ConfirmEmail.js
import React, { useEffect, useState } from "react";
import { auth, db } from "./firebase";
import { signInWithEmailLink, isSignInWithEmailLink } from "firebase/auth";
import { doc, setDoc, getDoc, serverTimestamp } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import { toast } from "react-toastify";
const FREE_SUBSCRIPTION_LIMIT = parseInt(process.env.REACT_APP_FREE_SUBSCRIPTION_LIMIT) || 5;
function ConfirmEmail() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("Procesando confirmación...");

  useEffect(() => {
    async function confirmEmailAndUpdateUser() {
      if (auth.currentUser) {
        toast.info("Ya estás autenticado. Redirigiendo...");
        setStatus("Redirigiendo...");
        navigate("/", { replace: true, state: { emailConfirmed: true } });
        return;
      }

      if (isSignInWithEmailLink(auth, window.location.href)) {
        let email = window.localStorage.getItem("emailForSignIn") || window.prompt("Introduce tu email:");
        if (!email) {
          setStatus("Se canceló el proceso de autenticación.");
          toast.warn("No se proporcionó un email válido.");
          return;
        }

        email = email.trim().toLowerCase();

        try {
          const result = await signInWithEmailLink(auth, email, window.location.href);
          const uid = result.user.uid;
          const pendingUrl = window.localStorage.getItem("pendingUrlToTrack");

          // 🔁 Si hay una URL pendiente, registrar el producto
          if (pendingUrl) {
            try {
              setStatus("Registrando producto...");
              const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
              const token = await result.user.getIdToken();

              const response = await fetch("https://europe-west1-avisamesibaja-be02c.cloudfunctions.net/apiTrack", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ url: pendingUrl, email, uid, userTimeZone }),
              });

              const data = await response.json();
              if (data.error) {
                toast.error(`❌ Error al registrar el producto: ${data.error}`);
              } else {
                toast.success("✅ Producto registrado correctamente.");
                try { sessionStorage.removeItem('alertProductDraft'); } catch { /* Optional draft storage. */ }
              }

              window.localStorage.removeItem("pendingUrlToTrack");
            } catch (err) {
              console.error("❌ Error al llamar a apiTrack:", err);
              toast.error("❌ Error al registrar el producto tras confirmar el email.");
            }
          }

          // 🔐 Crear o actualizar documento del usuario
          const userRef = doc(db, "users", uid);
          const userSnap = await getDoc(userRef);

          if (!userSnap.exists()) {
            await setDoc(userRef, {
              email,
              createdAt: serverTimestamp(),
              updatedAt: serverTimestamp(),
              isSubscribed: false,
              subscriptionLimit: FREE_SUBSCRIPTION_LIMIT,
              followedProducts: [],
            });
          } else {
            await setDoc(userRef, {
              email,
              updatedAt: serverTimestamp(),
            }, { merge: true });
          }

          toast.success("✅ Email confirmado. Redirigiendo...");
          window.localStorage.removeItem("emailForSignIn");
          setStatus("Redirigiendo a la app...");

          // Trackear registro completado por email
          if (window.gtag) {
            window.gtag('event', 'sign_up', {
              method: 'email'
            });
            window.gtag('event', 'conversion_event_subscribe_paid_1', {
              // event_parameters
            });
            console.log('Google Analytics: email confirmation sign_up tracked');
          }

          navigate("/", { replace: true, state: { emailConfirmed: true } });
        } catch (error) {
          console.error("Error en la confirmación:", error);
          toast.error("❌ Error en la confirmación del email.");
          setStatus("Error al confirmar el email.");
        }
      } else {
        toast.warn("⚠️ El enlace de confirmación no es válido.");
        setStatus("Enlace inválido.");
      }
    }

    confirmEmailAndUpdateUser();
  }, [navigate]);

  return (
    <div style={{ padding: 20 }}>
      <Navbar />
      <h1>Confirmación de Email</h1>
      <p style={{ marginTop: 10, fontStyle: "italic" }}>{status}</p>
    </div>
  );
}

export default ConfirmEmail;
